module.exports = __webpack_public_path__ + "img/1491514824.046a2d70.jpg";